/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Day_MondayInputs */

const en_coach_day_monday = /** @type {(inputs: Coach_Day_MondayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monday`)
};

const de_coach_day_monday = /** @type {(inputs: Coach_Day_MondayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montag`)
};

/**
* | output |
* | --- |
* | "Monday" |
*
* @param {Coach_Day_MondayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_day_monday = /** @type {((inputs?: Coach_Day_MondayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Day_MondayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_day_monday(inputs)
	return de_coach_day_monday(inputs)
});